export default __webpack_public_path__ + "static/media/LqdLogo.c116f96c.svg";